import { RouteRecordRaw } from "vue-router";
import { ROUTE_ADVISOR_DASHBOARD, ROUTE_ADVISOR_INVESTORS, ROUTE_ADVISOR_INVESTORS_CREATE, ROUTE_ADVISOR_INVESTORS_PROFILE } from "@/constants/routes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/advisor",
    redirect: ROUTE_ADVISOR_DASHBOARD,
  },
  {
    path: ROUTE_ADVISOR_DASHBOARD,
    component: () => import("../../views/Advisor/DashboardView.vue"),
    meta: {
      advisor: true,
    },
  },
  {
    path: ROUTE_ADVISOR_INVESTORS,
    component: () => import("../../views/Admin/InvestorsView.vue"),
    meta: {
      advisor: true,
    },
  },
  {
    path: ROUTE_ADVISOR_INVESTORS_CREATE,
    component: () => import("../../views/Advisor/CreateInvestorWizard/CreateInvestorWizardView.vue"),
    meta: {
      advisor: true,
    },
  },
  {
    path: `${ROUTE_ADVISOR_INVESTORS_PROFILE}/:id`,
    component: () => import("../../views/Admin/InvestorsProfile/ProfileView.vue"),
    meta: {
      advisor: true,
    },
  },
];

export default routes;
